// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import withStyles from '../../../../../../../common/hoc/withStyles';
import styles from './styles/PlccICPickupModal.view.style';
import Pickup from '../../../../../SinglePageCheckout/container/Pickup';

class PlccICPickupModal extends React.PureComponent {
  render() {
    const { openState, onRequestClose, shipments, isLoginV2FlowEnabled, pageCategory } = this.props;
    return (
      <Modal
        isOpen={openState}
        onRequestClose={onRequestClose}
        overlayClassName="TCPModal__Overlay"
        className="TCPModal__Content"
        inheritedStyles={styles}
        closeIconDataLocator="detailmodalcrossicon"
        fixedWidth
      >
        <Pickup
          isPlccIC
          shipments={shipments}
          pageCategory={pageCategory}
          isLoginV2FlowEnabled={isLoginV2FlowEnabled}
        />
      </Modal>
    );
  }
}
export { PlccICPickupModal as PlccICPickupModalVanilla };

export default withStyles(PlccICPickupModal, styles);
